export default "__VITE_ASSET__Cym6bDd6__"